export enum AtomAvatarSizeEnum {
  LARGE = "large",
  REGULAR = "regular",
  SMALL = "small",
}
